import React, { FC } from 'react';
import { Optin } from '../../services/optinService';
import { ToggleButton } from '../ToggleButton';
import Loader from './Loader';

type OptinListProps = {
  loading?: boolean;
  optins: Optin[];
  onChange: (optins: Optin[]) => void;
};

const OptinList: FC<OptinListProps> = ({ optins, onChange, loading }) => {
  function updateOptin(optin: Optin, newState: boolean) {
    const oldOptin = optins.find((o) => o.optinKey === optin.optinKey);
    if (oldOptin) {
      oldOptin.checked = newState;
      onChange(optins);
    }
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}>
          {optins.map((optin) => (
            <ToggleButton
              label={optin.optinText}
              id={`register__form-optin-${optin.optinKey}`}
              key={optin.optinKey}
              checked={optin.checked}
              onChange={(checked: boolean) => {
                updateOptin(optin, checked);
              }}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default OptinList;
